
export const environment = {
  production: false,
  commonPaymentApiBasePath : 'https://dev.paybyphone.cinchhs.com/commonPayment/',
  ivrCallTransfer: 'https://apis.qa.accelerate.cinchhs.com/paymentsvc/api/callmonitor/',
  originalPaymentUIDomain: 'https://dev.payment.cinchhs.com/'
};
